module.exports = __webpack_public_path__ + "img/certificate_03@2x.f542da83.png";